import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";

export const getBenchmarkJfaCount = async () => {
  return base.get({
    url: `${API_PARAM.BENCHMARK_JFA_COUNT}`,
  });
};

export const exportBenchmarkJFAGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.BENCHMARK_JFA_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.BENCHMARK_JFA),    
  });
};

export const uploadBenchmarkJFA = async () => {
  return base.post({
    url: `${API_PARAM.BENCHMARK_JFA_UPLOAD}`,
  });
};